import {useTranslation} from "@unibuddy/intl";
import {Box, Text, VisuallyHidden} from "@unibuddy/patron";
import React, {useEffect} from "react";
import {useLocation} from "react-router-dom";
import {sharedEvents} from "shared/AnalyticsNew/constants/productSpecification";
import useAnalytics from "shared/AnalyticsNew/hooks/useAnalytics";
import PageTitle from "shared/Shared/components/PageTitle/PageTitle";
import {
    DecisionStagePageTitle,
    DecisionStagePageSubtitle,
    ProspectStageLocation,
} from "../../Chat/components/PopupQuestions/prospectStages";
import {DecisionStageFormContainer} from "../components/DecisionStageForm";
import {useUniversity} from "../../UniversityProvider/UniversityProvider";

function useSearchQuery() {
    const {search}: {search: string} = useLocation();
    return React.useMemo(() => new URLSearchParams(search), [search]);
}

export function DecisionStagePage() {
    const {trackEvent} = useAnalytics();
    const university = useUniversity();
    const searchQuery = useSearchQuery();
    const template = searchQuery.get("template");
    const {t, ready} = useTranslation("decisionStage");

    useEffect(() => {
        trackEvent(sharedEvents.prospectDecisionStagesShown.name, {
            universityId: university.id,
            universityName: university.name,
            where: ProspectStageLocation.WIDGET_DECISION_PAGE,
            templateLinkedFrom: template ?? "unknown",
        });
    }, [university, trackEvent, template]);

    if (!ready) return <p>Loading...</p>;

    // TODO: Upgrade PageTitle component to tsx so title can be passed directly
    const pageTitleProps = {
        title: t(DecisionStagePageTitle.translationKey, DecisionStagePageTitle.name),
    };

    return (
        <Box>
            <VisuallyHidden>
                <PageTitle {...pageTitleProps} />
            </VisuallyHidden>
            <Box paddingBottom="medium" paddingTop="xxsmall">
                <Text size="large">
                    {t(DecisionStagePageSubtitle.translationKey, DecisionStagePageSubtitle.name)}
                </Text>
            </Box>
            <DecisionStageFormContainer
                decisionStageLocation={ProspectStageLocation.WIDGET_DECISION_PAGE}
            />
        </Box>
    );
}
